import * as React from "react";

export const Select = ({ column, value, handleChange, disabled }) => {
	const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
		handleChange(event.currentTarget.value);
	};

	return (
		<select className="form-control" onChange={handleSelect} disabled={disabled} value={value}>
			{column?.options?.map((option) => {
				const _label = option?.label?.ru ?? option?.value?.ru;

				if (!option) {
					return <option key={0} value={null} aria-label="пусто" />;
				}

				return <option key={_label}>{_label ?? "Выберите из списка"}</option>;
			})}
		</select>
	);
};
